import React, { useCallback } from 'react';

// DEPENDENCIES
import { useFormikContext } from 'formik';

// HOOKS
import useRecordView from 'helpers/getRecordView';

// CORE COMPONENTS
import Form from 'core/form/Form';

// LOCAL HELPERS
import { useUploadHelpers } from '../helpers/useUploadHelpers';

// LOCAL COMPONENTS
import DownPaymentAttachments from './DownPaymentAttachments';

// VARIABLES
const OPTION_KEYS = {
  label: 'down_payment_type_name',
  value: 'down_payment_type_id'
};
const ITEM_CONSTRUCTOR = obj => ({
  dp_type: obj?.down_payment_type_id,
  down_payment_type_name: obj?.down_payment_type_name,
  down_payment_id: '',
  dp_Amount: '',
  dp_description: '',
  is_task: false,
  is_task_completed: false,
  aryDownpaymentAttachment: []
});

// MAIN COMPONENT
const DownPaymentTable = () => {

  // CONTEXT
  const { isAdd } = useRecordView();

  // FORMIK
  const { setFieldValue } = useFormikContext() || {};
  
  const handleChange = useCallback(
    (item, i) => {
      if (!isAdd && item.down_payment_id !== '') {
        setFieldValue(`aryDownPayment[${i}].isUpdated`, true);
      }
    },
    [setFieldValue, isAdd]
  );

  const handleDelete = useCallback(
    (item, i) => {
      if (!isAdd && item.down_payment_id !== '') {
        setFieldValue(`aryDownPayment[${i}].isUpdated`, false);
        setFieldValue(`aryDownPayment[${i}].isDeleted`, true);
        return true;
      } else return false;
    },
    [setFieldValue, isAdd]
  );

  // RENDER
  return (
    <Form.Body>
      <Form.Table
        name="aryDownPayment"
        itemLabel="Down Payment"
        lookup="downPayment"
        optionKeys={OPTION_KEYS}
        itemConstructor={ITEM_CONSTRUCTOR}
        buttons={[
          {
            as: DownPaymentAttachments.Button,
            icon: 'attachment',
            label: 'Add Attachment'
          }
        ]}
        buttonBefore
        itemWrapper={useUploadHelpers}
        handleDelete={(item, i) => handleDelete(item, i)}
      >
        {(item = {}, i) => [
          <Form.Col colWidth={4} label="Method" className="p-0">
            <Form.Label>
              {item.down_payment_type_name?.includes('By')
                ? item.down_payment_type_name
                : `By ${item.down_payment_type_name}`}
            </Form.Label>
          </Form.Col>,
          <Form.Control
            name="dp_Amount"
            label="Amount"
            schema="dollars"
            colWidth={6}
            onChange={() => handleChange(item, i)}
            required
          />,
          <Form.Control
            name="dp_description"
            label="Description"
            maxLength={100}
            onChange={() => handleChange(item, i)}
            colWidth={10}
          />,
          <Form.YesNo
            name="is_task"
            text="Add as Task"
            type="checkbox"
            numeric={false}
            onChange={() => handleChange(item, i)}
            colWidth={4}
          />,
          <DownPaymentAttachments index={i} />
        ]}
      </Form.Table>
    </Form.Body>
  );
};

export default DownPaymentTable;
